import { useEffect, useState } from 'react';

export default function RainbowDragon2026001Page() {
  const [timeLeft, setTimeLeft] = useState({
    days: 36,
    hours: 15,
    minutes: 57,
    seconds: 37
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { days, hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        
        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* カウントダウンヘッダー */}
      <div className="bg-gradient-to-r from-amber-50 to-orange-50 py-4 sticky top-0 z-50 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center">
            <div className="text-sm font-medium text-gray-700 mb-2">申し込み終了まで</div>
            <div className="flex gap-4">
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-orange-600">{timeLeft.days}</span>
                <span className="text-xs text-gray-600">日</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-orange-600">{timeLeft.hours}</span>
                <span className="text-xs text-gray-600">時間</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-orange-600">{timeLeft.minutes}</span>
                <span className="text-xs text-gray-600">分</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-orange-600">{timeLeft.seconds}</span>
                <span className="text-xs text-gray-600">秒</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 max-w-5xl">
        {/* メインタイトル画像 */}
        <div className="mb-8">
          <img 
            alt="レインボードラゴン・マスター" 
            className="w-full h-auto" 
            src="https://keikoanaguchi.com/RD24/Newtitle.png"
          />
        </div>

        {/* リンクナビゲーション */}
        <div className="text-center mb-8 text-sm">
          <a 
            href="https://dynavision.co.jp/mensekijikou.html" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-600 hover:text-orange-600 mx-2"
          >
            免責事項
          </a>
          <span className="text-gray-400">|</span>
          <a 
            href="https://dynavision.co.jp/sub04_02.html" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-600 hover:text-orange-600 mx-2"
          >
            キャンセル規定
          </a>
          <span className="text-gray-400">|</span>
          <a 
            href="https://dynavision.co.jp/sub04_03.html" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-600 hover:text-orange-600 mx-2"
          >
            プライバシーポリシー
          </a>
        </div>

        {/* 申し込みボタン */}
        <div className="text-center mb-12">
          <a 
            href="https://rainbowshop.lolipop.jp/rainbowangel/landing/LuckyBag2026/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block"
          >
            <img 
              alt="規約に同意して申し込む" 
              className="w-full max-w-2xl h-auto hover:opacity-90 transition-opacity cursor-pointer" 
              src="https://keikoanaguchi.com/RD24/moushi.png"
            />
          </a>
        </div>

        {/* YouTube動画1 */}
        <div className="mb-12">
          <div className="aspect-video w-full max-w-3xl mx-auto">
            <iframe 
              width="100%" 
              height="100%" 
              src="https://www.youtube.com/embed/IQx4KVHlfJc?si=UrD2Bmsef6Sna_Q5" 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowFullScreen 
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>

        {/* YouTube動画2 */}
        <div className="mb-12">
          <div className="aspect-video w-full max-w-3xl mx-auto">
            <iframe 
              width="100%" 
              height="100%" 
              src="https://www.youtube.com/embed/EBQG-Z1FBlc?si=luKscRaVcXRU4Kzq" 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowFullScreen 
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>

        {/* セクション1: 龍やドラゴンが好きなあなたへ */}
        <div className="prose prose-lg max-w-none mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">龍やドラゴンが好きなあなたへ</h2>
          
          <div className="mb-8">
            <img 
              alt="龍のイメージ" 
              className="w-full h-auto rounded-lg shadow-md mb-6" 
              src="https://keikoanaguchi.com/RD24/img01.jpg"
            />
          </div>

          <div className="text-base leading-relaxed text-gray-700 space-y-4">
            <p>10年ほど前から龍使いの方が増えてきていますね。</p>
            
            <div className="space-y-2 my-6">
              <p className="font-semibold">「龍使いではないけど、龍にはご縁がある!」</p>
              <p className="font-semibold">「龍が大好き!」</p>
              <p className="font-semibold">「私には龍がついて護ってくれている」</p>
              <p className="font-semibold">「龍雲が見えた!」</p>
              <p className="font-semibold">「龍神やドラゴンにサポートされている」</p>
              <p className="font-semibold">「私は龍と仲良し!」</p>
              <p className="font-semibold">「龍グッズが大好き」</p>
            </div>

            <p>という方も増えてきましたよね。</p>
            <p>なぜこんなに龍やドラゴンが好きな人が増えてきているのでしょう・・・</p>
            
            <p className="text-lg font-bold text-red-600 my-6">
              それは世界中の龍やドラゴンが地球のアセンションの強力なサポートをしているからです。
            </p>

            <p>龍やドラゴンは西洋東洋問わず、恐れられる存在でもありました。</p>
            <p>なぜなら、彼らはダイナミックなエネルギーを持ち、規格外で改革的で自由な性質を持ち合わせている存在。</p>
            
            <p className="text-lg font-bold text-red-600 my-6">
              だから、大変革期の今の地球には自由でダイナミックなエネルギーを持つ龍やドラゴンが求められているのです!
            </p>

            <p className="font-semibold">
              <span className="text-red-600">もし、あなたも龍やドラゴンに惹かれるなら、</span>
              同じように、自由で革新的でダイナミックな素質を持っているのかもしれませんね。
              そんなあなたにぴったりな情報を今からお届けいたしますので、このまま続きを読み進めていただけたらと思います。
            </p>
          </div>
        </div>

        {/* セクション2: 7つのドラゴン */}
        <div className="mb-12 bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-8">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            7つのドラゴンが1つとなった<br />特別なレインボードラゴン
          </h2>

          <div className="flex flex-col md:flex-row gap-6 items-start mb-6">
            <img 
              alt="レインボードラゴン" 
              className="w-full md:w-64 h-auto rounded-lg shadow-md" 
              src="https://keikoanaguchi.com/RD24/img04.jpg"
            />
            <div className="flex-1 text-base leading-relaxed text-gray-700 space-y-4">
              <p>穴口恵子のもとに、2008年の夏に沖縄の首里城で、レインボードラゴン(虹の龍)が現れました。</p>
              <p>これまでは、ドラゴンはそれぞれの色で認識されており、役割が分担されていました。ドラゴンは、天に与えられた使命を遂行する存在です。</p>
              <p className="font-semibold">
                それぞれの役割や使命を終えて各色のドラゴンは、地球の最高最善の文明に貢献するために、セブンレイズ(7つの光)を統合しました。それが、パワフルで聖なるレインボードラゴン(虹の龍)です。
              </p>
            </div>
          </div>

          <div className="bg-white rounded-lg p-6 mb-6 shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <div className="flex items-start gap-2">
                <span className="font-bold text-amber-600">1.</span>
                <div><strong>ゴールデン ドラゴン</strong> 金運や夢の実現</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-gray-400">2.</span>
                <div><strong>シルバー ドラゴン</strong> 魂の導き、受容力</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-red-600">3.</span>
                <div><strong>レッド ドラゴン</strong>(紅龍) バイタリティ、生命力</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-orange-600">4.</span>
                <div><strong>オレンジ ドラゴン</strong> 創造性、情熱</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-yellow-600">5.</span>
                <div><strong>イエロー ドラゴン</strong> 自信、信頼</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-green-600">6.</span>
                <div><strong>グリーン ドラゴン</strong> 癒し、怖れからの自由</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-cyan-600">7.</span>
                <div><strong>ブルー ドラゴン</strong> 静寂さ、表現力</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-indigo-600">8.</span>
                <div><strong>インディゴ ドラゴン</strong> 未来への夢、希望</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-purple-600">9.</span>
                <div><strong>パープル ドラゴン</strong> 多次元からの智恵</div>
              </div>
              <div className="flex items-start gap-2">
                <span className="font-bold text-pink-600">10.</span>
                <div><strong>ピンク ドラゴン</strong> 愛</div>
              </div>
            </div>
          </div>

          <div className="text-base leading-relaxed text-gray-700 space-y-4">
            <p>レインボードラゴンの役目は、全てのドラゴンの叡智を統合し、状況や環境に応じて必要な叡智を人間に授けることです。そして、人類と地球の進化を支えてくれます。</p>
            <p>また、レインボードラゴンは全てを調和し、ワンネスの意識を人類にもたらしながら、ワンネスの原理を基盤とした文明を開く"鍵"を握っています。レインボードラゴン使いになるあなたを、ワンネスの意識へと導きます。</p>
          </div>
        </div>

        {/* セクション3: レインボードラゴンと繋がる */}
        <div className="mb-12 text-base leading-relaxed text-gray-700 space-y-4">
          <p className="font-semibold">
            レインボードラゴンと繋がっていると、それだけで心強くなることができます。また、レインボードラゴンの高い次元に触れていると、波動が高くなり、ドラゴンが持っている特色を効果的に引き寄せます。
          </p>
          <p>
            穴口恵子が、いつでも誰とどこにいても楽しむことが出来る秘訣のひとつが、
            <u>レインボードラゴンと繋がって一瞬一瞬の今を生きている</u>ことなのです。
          </p>
          <p>そして、穴口恵子はたくさんの人を癒し、成長を助け、ライトワーカーを育てるという使命に誇りを持って活動しています。</p>
          <p>
            それは特別な人だけができるというわけではありません。
            <strong>あなたが自分自身の天才性と周りの天才性を輝かせて、高い意識とバイブレーションで日々を満喫し、あなたの大きな夢や希望を実現していくように導いていきます。</strong>
          </p>
        </div>

        {/* セクション4: 恐れや不安の次元 */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            あなたは恐れや不安の次元に<br />これからも生き続けますか?
          </h2>

          <div className="mb-8">
            <img 
              alt="変革のイメージ" 
              className="w-full h-auto rounded-lg shadow-md" 
              src="https://keikoanaguchi.com/RD24/newimg01.jpg"
            />
          </div>

          <div className="text-base leading-relaxed text-gray-700 space-y-4">
            <p>
              <strong className="text-red-600">今地球は大変革期に突入している</strong>
              ことをあなたも実感しているかもしれません。大変革期に<strong>"恐れ"</strong>や<strong>"不安"</strong>に巻き込まれている人が増えています。
            </p>
            <p>コップに半分注がれた水の話をご存知ですか?</p>
            <p>コップに入った半分の水を見て「まだ半分ある」と考えるか、「半分しかない」と考えるか。同じものを見ていても、考え方の違いで人生が変わるとよく言われています。</p>
            <p>「まだ半分ある」という"豊かな意識"でいたいと思いながらもついつい「半分しかない」という意識になってしまっていませんか?</p>
            <p className="font-semibold">大丈夫です、あなただけではありません。</p>
            <p>たくさんの人がその意識のなかで生きています。</p>
            <p>空っぽの半分にあるのは「さらに無くなるのではないか」「もっと悪くなるのではないか」という不安や恐れ。</p>
            <p>しかし、どのような情勢、環境にいても恐れず慌てず「私には半分もある!」と思って安心して、喜びと愛の中で生活している人もいます。</p>
            <p>
              それは、<strong className="text-red-600">"宇宙の無限の豊かさのボルテックス"</strong>の中で
              <u>【宇宙の無限の豊かさ】にアクセスし続けている人、</u>
              <strong>穴口恵子もその一人です。</strong>
            </p>
            <p>
              その人にとって、水の入っていない半分は
              <span className="text-red-600 font-semibold">"まだ現実化されていない無限の可能性のエネルギー"</span>
              で満たされています。
            </p>
            <p>
              それが水になるのか、はたまた美味しいフレッシュジュースやレアなお酒になるかまだ分からないけれど、
              <u>自分が欲しい豊かさをこれから現実化するための余白の部分です。</u>
            </p>
            <p className="text-lg font-bold text-red-600">
              あなたに必要なのは、宇宙の無限の豊かさのボルテックスの中で生きるのを選択すること。
            </p>
            <p>
              レインボードラゴンは革新的で、自由でダイナミックな存在。無限の豊かさのボルテックスの中で新しい地球を生み出すべく、ダイナミックに動いています。
              <strong>無限の豊かさのボルテックスにい続けているレインボードラゴンに導かれることで、"まだ見ぬ無限の可能性、豊かさ"を受け取り続けることが可能になります。</strong>
            </p>
          </div>
        </div>

        {/* セクション5: 大浄化 */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            宇宙の無限の豊かさのヴォルテックスに入る前に・・・<br />怖れや不安を大浄化すること。
          </h2>

          <div className="mb-8">
            <img 
              alt="浄化のイメージ" 
              className="w-full h-auto rounded-lg shadow-md" 
              src="https://keikoanaguchi.com/RD24/img0001.jpg"
            />
          </div>

          <div className="text-base leading-relaxed text-gray-700 space-y-4">
            <p>
              <strong>
                <u>たくさんの恐れや不安の中にいながら</u>、宇宙の無限の豊かさのボルテックスに入ったとしてもあなたはその豊かさに気づくことはできないでしょう。
              </strong>
            </p>
            <p className="text-lg font-bold text-red-600">大切なのは、まずあなたの恐れや不安を大浄化すること。</p>
            <p>でも、そうは言っても、このご時世…</p>

            <div className="space-y-2 my-6">
              <p className="font-semibold">「毎日不安です!」</p>
              <p className="font-semibold">「毎日憂鬱です!」</p>
              <p className="font-semibold">「おカネが…」</p>
              <p className="font-semibold">「恐れのほうが気になります!」</p>
            </div>

            <p>どうしても<strong>恐れ</strong>や<strong>不安</strong>、<strong>不足</strong>のほうに意識が行ってしまいますよね…その気持ち、よくわかります。</p>
            <p>
              こく一刻と大変化が起きている<strong>「今」</strong>だからこそ、今まで持ち続けている、そして今特に浮かび上がっている恐れや不安をレインボードラゴンの七色の粒子(龍子)で細やかに、そしてダイナミックに浄化していきます。
            </p>
            <p className="text-lg font-semibold">
              <span className="text-red-600">恐れや不足という世界から、ダイナミックで豊かな無限の可能性に意識が大きくシフトしていきます。</span>
              ですので、無限の豊かさのボルテックスにいつでもアクセスできることで、これまでの恐れや不安の思考パターンも外れていくでしょう。
            </p>
          </div>
        </div>

        {/* セクション6: ヒーラー向け情報 */}
        <div className="mb-12 space-y-6">
          <div className="bg-gradient-to-r from-cyan-50 to-teal-50 rounded-lg p-6 shadow-sm">
            <h3 className="text-xl font-bold mb-4 text-gray-800">◆ 既にヒーラーをされている方</h3>
            <div className="text-base leading-relaxed text-gray-700 space-y-3">
              <p>ご自身のセッションメニューの中に遠隔ヒーリングを追加できます。(対面でもヒーリング&アクティベーションを行うことができます。)</p>
              <p>このコースを修了すると今回あなた自身が穴口から受け取っていただく遠隔ヒーリングサービスをあなたのクライアントにも提供していただけるようになります。</p>
              <p className="text-sm">※1回の遠隔ヒーリングにつき希望価格:15000円以内で価格設定していただいてサービスの提供ができます。</p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-cyan-50 to-teal-50 rounded-lg p-6 shadow-sm">
            <h3 className="text-xl font-bold mb-4 text-gray-800">◆ ヒーラー未経験の方へ</h3>
            <div className="text-base leading-relaxed text-gray-700 space-y-3">
              <p>この遠隔ヒーリングを使い、ヒーラーとしてデビューすることができます。<u>遠隔ヒーリングは対面のみならず、遠隔で行う事ができるため、人数、時間、場所にとらわれずどこでもサービスの提供が可能です。</u></p>
              <p>あなたがまだ会社にお勤めであったり、小さなお子さんがいたり、ご家族の介護などの理由で外出する事が難しくても大丈夫です。この遠隔ヒーリングを取り入れる事で、場所に関わらずヒーラーとしてのキャリアをスタートさせる事が可能ですので安心してください。</p>
            </div>
          </div>
        </div>

        {/* セクション7: おすすめの方 */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            レインボードラゴン・マスタースクールは<br />こんな方におすすめです!
          </h2>

          <div className="space-y-3 text-base">
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>龍やドラゴンが好き。彼らとご縁を結んだり、深めたい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>レインボードラゴンが授けてくれる叡智や豊かさを、自由に受け取りたい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>レインボードラゴンとともに新しい世界を創造したい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>自分を癒し、そして他の方を癒せるヒーラーになりたい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>周りの人や地球の最高・最善のために貢献したい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>この非常事態の中でも、どんな状況にも左右されず、自分や周りを癒す力を発揮したい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>「私の人生これでいいの?」と漠然とした不安がある方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>「スピリチュアルを仕事にしたい」「好きなことを仕事にしたい」と考えている方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>自己ケアや誰かのためにヒーリングを身に着けたい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>既にヒーラーで、新しいスキルを身につけて新しいクライアントと出会いたい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>自己愛、自己信頼を高めたい方</p>
            </div>
            <div className="flex items-start gap-3 text-teal-700">
              <span className="text-xl mt-1">⭐️</span>
              <p>自信がないけどヒーラーやスピリチュアルな仕事・活動に興味がある方</p>
            </div>
          </div>
        </div>

        {/* セクション8: 受けると... */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">この養成コースを受けると…</h2>

          <div className="text-base leading-relaxed text-gray-700 space-y-6">
            <div>
              <p className="font-bold text-lg mb-3">
                <u>◆あなたは、宇宙の無限の豊かさのボルテックスの中で<span className="text-red-600">レインボードラゴンヒーラー</span>として "癒しや可能性を与える人"へと覚醒します。</u>
              </p>
              <p>穴口恵子によるレインボードラゴン・マスタースクールでは、龍使いになるための秘伝のワークだけでなく、あなた自身が癒され、エネルギーが内側から活性化していく遠隔ヒーリング&アクティベーションも組み込まれています。日常の何気ない恐れから、未来に対する不安など、重いものを大浄化し、レインボードラゴンの無限の豊かさのボルテックスに導かれるプログラムがこのレインボードラゴン・マスタースクールにはたっぷりと含まれております。</p>
            </div>

            <div>
              <p className="font-bold text-lg mb-3">
                <u>◆あなたがレインボードラゴンと人々とのご縁を繋ぐヒーラーになること!</u>
              </p>
              <p>恐れや不安で気持ちが引きこもっている人々を、あなたが遠隔で癒し、アクティベートし、レインボードラゴンのようにダイナミックで豊かな天命を生きる、新しい世界で生きることをサポートするのです。</p>
            </div>

            <div>
              <p className="font-bold text-lg mb-3">
                <u>◆全くの未経験で「レインボードラゴン・マスター」としてデビュー可能です!</u>
              </p>
              <p>今回はできるだけ多くの方にレインボードラゴンとご縁を繋いでいただきたい、この時期だからこそ、たくさんの方が自分にも他者へも癒しと覚醒を与えられる人としてデビューしていただきたいということで、"全く初めての方でも、レインボードラゴン・マスターになれる"方法を採用しました。</p>
              <p>例えば、電話やZOOM等でお客様とあなたを繋いで、穴口恵子の音声を流してお客様に聞かせることでレインボードラゴンを呼び、レインボードラゴンとご縁を繋ぐことが出来るのです。</p>
            </div>
          </div>
        </div>

        {/* セクション9: 3つの理由 */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            なぜ今、レインボードラゴン・マスターが<br />あなたにとって重要な「スキル」になるのか?<br />
            <span className="text-red-600">3つの理由</span>
          </h2>

          <div className="space-y-8">
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold mb-4 text-red-600">理由1</h3>
              <p className="font-bold text-lg mb-3">
                あなたの大切な家族や友人、パートナー、仲間、そしてあなた自身の不安や恐怖を癒すことができる!
              </p>
              <div className="text-base leading-relaxed text-gray-700 space-y-3">
                <p>今、日本のみならず世界規模で「どうなってしまうのか」といった不安で精神的なストレスも非常に大きな問題になっていますよね。</p>
                <p>不安や恐怖そのものが人々を疲労させ人生を圧迫しているように感じます。</p>
                <p>まず自分自身をクリアにして、あなたの大切な人の心も癒すことができます。</p>
                <p>今、ヒーリングは求められている重要なスキルです。</p>
                <p>このレインボードラゴン・マスターは、ただあなたが龍と仲良しになるだけではなく、人生を好転させていく波動を身につけ、他者貢献に繋げる方法を学んでもらうコースです。</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold mb-4 text-red-600">理由2</h3>
              <p className="font-bold text-lg mb-3">
                今は、皆が発信者の時代。あなたが新時代をリードしていける!
              </p>
              <div className="text-base leading-relaxed text-gray-700 space-y-3">
                <p>今、世界は急速にオンライン化が進んでいます。</p>
                <p>各業界でオンライン対応する必要が出てきたためこれまでにないスピードで人類のコミュニケーション方法は進化しています。</p>
                <p>今は生き残るために必要だからやっているわけですが</p>
                <p>コロナ禍の後、このコミュニケーションの進化は働き方やライフスタイルを大きく変わりつつあります。</p>
                <p>そんな、変化が多様な時代にはより一層、癒しや本質に繋がるためのスピリチュアル・スキルのニーズも増えていくでしょう。</p>
                <p>あなたがヒーラーとして今から一歩を踏み出すことで、これからの新時代の波に乗りやすくなります。</p>
                <p>今のうちにスピリチュアルなスキルを学んでおくことは自分自身を癒したり 今、不安になっている人をサポートできるだけでなく</p>
                <p>不安で無機質な時代だからこそ、「私がすごく不安だった時に、あの人のヒーリングに救われたの」</p>
                <p>と、その道のプロとして時代をリードし、このヒーリングを提供できるようになることで、</p>
                <p>不安、恐怖、混乱してしまっている人々を癒し、喜んで社会貢献しながら豊かさも受け取ることに繋がります。</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold mb-4 text-red-600">理由3</h3>
              <p className="font-bold text-lg mb-3">
                あなたのペースで、いつでも好きな場所から収入の入り口を増やすことができる!
              </p>
              <div className="text-base leading-relaxed text-gray-700 space-y-3">
                <p>働き方改革はずっと不評だったようですが、今は否が応にも働き方を改革しなければいけない時。</p>
                <p>そんな状況の中で「龍と繋がる」ということは、経済的にも精神的にもあなたに安心感をもたらすでしょう。</p>
                <p>龍は古来より、エネルギーが非常に高く、人の素質を活かすサポートをしているからです。人間は本来、すべての人が表現者であり、才能があるということを教えてくれます。</p>
                <p>魂に刻まれた自分の力や、まだ知らない自分のこと、望む状態など、エネルギーを調整して、あなた本来のピュアな波動に近づけるサポートをもたらします。</p>
                <p>重要なのは、波動の状態を整えキープし続けることなのです。</p>
                <p>このコースでは、龍と繋がることをしっかりと学べます。</p>
                <p>また、自分自身のメンテナンスにもお役立てください!</p>
              </div>
            </div>
          </div>
        </div>

        {/* 申し込みボタン2 */}
        <div className="text-center mb-12">
          <div className="text-sm mb-4">
            <a 
              href="https://dynavision.co.jp/mensekijikou.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              免責事項
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_02.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              キャンセル規定
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_03.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              プライバシーポリシー
            </a>
          </div>
          <a 
            href="https://rainbowshop.lolipop.jp/rainbowangel/landing/LuckyBag2026/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block"
          >
            <img 
              alt="規約に同意して申し込む" 
              className="w-full max-w-2xl h-auto hover:opacity-90 transition-opacity cursor-pointer" 
              src="https://keikoanaguchi.com/RD24/moushi.png"
            />
          </a>
        </div>

        {/* セクション10: 喜びの声 */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">遠隔ヒーラーになった方の喜びの声</h2>

          <div className="space-y-4">
            <div className="flex gap-4 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center">
                <i className="ri-user-smile-line text-xl text-purple-700"></i>
              </div>
              <div className="flex-1 bg-white rounded-lg shadow-sm p-4 border border-gray-100">
                <p className="text-gray-700 mb-2">1年で100人に遠隔セッションして、収入が150万円アップしました。</p>
                <div className="text-sm text-gray-500">MKさま</div>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center">
                <i className="ri-user-smile-line text-xl text-purple-700"></i>
              </div>
              <div className="flex-1 bg-white rounded-lg shadow-sm p-4 border border-gray-100">
                <p className="text-gray-700 mb-2">クライアントのリピート率が20%アップしました。何よりも、自分が提供しているセッションの内容がパワーアップしたことが感じられます。</p>
                <div className="text-sm text-gray-500">TYさま</div>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center">
                <i className="ri-user-smile-line text-xl text-purple-700"></i>
              </div>
              <div className="flex-1 bg-white rounded-lg shadow-sm p-4 border border-gray-100">
                <p className="text-gray-700 mb-2">自己信頼と自分軸が持てるようになり、自信を持ってヒーリングセッションできるようになりました。</p>
                <div className="text-sm text-gray-500">KHさま</div>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center">
                <i className="ri-user-smile-line text-xl text-purple-700"></i>
              </div>
              <div className="flex-1 bg-white rounded-lg shadow-sm p-4 border border-gray-100">
                <p className="text-gray-700 mb-2">自己に刻まれた自分の天命が自然にわかったので、天命は探す必要はないことがわかって、毎日がしっくり来るようになりました。自分のプロとしての意識が高まりました。</p>
                <div className="text-sm text-gray-500">JYさま</div>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center">
                <i className="ri-user-smile-line text-xl text-purple-700"></i>
              </div>
              <div className="flex-1 bg-white rounded-lg shadow-sm p-4 border border-gray-100">
                <p className="text-gray-700 mb-2">インスピレーションが降りてきて、自分が何をしたらクライアントに貢献できるかがわかりました。そのことを実行したら、クライアントの人数が月々25人だったのが、40名に増えたので、収入アップに繋がりました。</p>
                <div className="text-sm text-gray-500">MTさま</div>
              </div>
            </div>
          </div>
        </div>

        {/* セクション11: 価格 */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            一生モノのスピリチュアル・スキル<br />『レインボードラゴン・マスター』<br />あなたにとっての価値は?
          </h2>

          <div className="mb-8">
            <img 
              alt="価格イメージ" 
              className="w-full h-auto rounded-lg shadow-md" 
              src="https://keikoanaguchi.com/RD24/newimg02.jpg"
            />
          </div>

          <div className="text-base leading-relaxed text-gray-700 space-y-4 text-center">
            <p>穴口恵子の提供するこのようなコースは、98,000円もありましたが、</p>
            <p>今、世界中で不安や恐れが広がる中で癒しと希望を選択し、ヒーラーとして一歩を踏み出す方を応援したい!</p>
            <p>という想いを込めて・・・</p>
            <p>一人でも多くの方に、この愛にあふれる重要なスキルを受け取っていただきたく、今回は【 特別価格 】でお申し込みいただけるようにしました。</p>
            <p className="text-lg">レムリアや縄文、そして日本人として生まれたあなたが虹の龍とご縁を繋ぎ、道を切り開いていくために、</p>
            <p className="text-xl font-bold">あなたを応援します</p>
            <p className="text-3xl font-bold text-red-600">特別価格 55,000円 (税込)</p>
            <p>でご提供いたします!</p>
            <p className="text-sm">※クレジット決済の場合、お申し込み時分割払いが選択可能です。</p>
            <p className="mt-6">これからの時代は、龍がますます必要とされます。すでに、龍やドラゴンに惹かれつつある方もいるはずです。</p>
            <p>大切な人や、悩み・不安を持つクライアントさんにもレインボードラゴン・マスタースクールで学んだことを活かして、あなたの存在価値を思う存分に発揮して活躍し、経済的な豊かさも受け取ってください!そして愛する人たちとともにダイヤモンドのようにキラキラと輝いてください!</p>
          </div>
        </div>

        {/* 注意事項 */}
        <div className="mb-12 bg-amber-50 rounded-xl p-8 border-2 border-amber-200">
          <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">ですが、ご注意ください</h2>
          <div className="text-base leading-relaxed text-gray-700 space-y-3 text-center">
            <p>今回も【期間限定】でのご案内となりますので、「申し込もうと思ったら、募集が終わっていた・・・」ということがないようにご注意ください。</p>
            <p>【期間限定】のこの情報に出会えたあなたは、ラッキーです。</p>
            <p>風の時代に突入して、大激動の新世界だからこそ、このスピリチュアル・スキルをぜひ受け取ってください。</p>
            <p>20年間で参加者15万人以上!数々のヒーリングコースを提供してきた穴口恵子からたっぷりとエッセンスを受け取ってください!</p>
          </div>
        </div>

        {/* 詳細テーブル */}
        <div className="mb-12 overflow-x-auto">
          <table className="w-full border-collapse bg-white shadow-sm rounded-lg overflow-hidden">
            <tbody>
              <tr className="bg-amber-50">
                <td colSpan={2} className="p-4 text-center font-bold text-lg">
                  レインボードラゴン・マスター<br />~虹の龍と次元上昇する方法~
                </td>
              </tr>
              <tr>
                <td className="bg-amber-50 p-4 font-bold text-center w-48">実施日</td>
                <td className="p-4">
                  オンライン動画のため、受講料金をお支払い(クレジットカードの場合は決済)後、7日以内にメールでコンテンツをお送りいたします
                </td>
              </tr>
              <tr>
                <td className="bg-amber-50 p-4 font-bold text-center">価格</td>
                <td className="p-4">
                  <p className="mb-4">通常価格<br /><s>98,000円</s> ▼</p>
                  <p className="mb-4">
                    グッズなし、単体<br />特別価格<br />
                    <span className="text-red-600 font-bold text-xl">55,000円 (税込)</span>
                  </p>
                  <p className="mb-2">開運アクティベーション福袋<br />VIP開運リチュアルBOX</p>
                  <p className="mb-2">通常価格<br />▼</p>
                  <p className="text-cyan-600 font-bold text-xl mb-2">特別価格</p>
                  <p className="text-xs text-gray-600 mt-2">※グッズの発送は、2月上旬を目処にお届けを予定しております。</p>
                </td>
              </tr>
              <tr>
                <td className="bg-amber-50 p-4 font-bold text-center">ご入金締切</td>
                <td className="p-4">
                  <p className="mb-2">
                    <strong>■銀行振込を選択される場合</strong><br />
                    お申込みから7日以内にお振込みを完了してください。
                  </p>
                  <p>
                    <strong>■クレジットカード決済を選択される場合</strong><br />
                    お申込みと同時に受講料が決済されます。
                  </p>
                </td>
              </tr>
              <tr>
                <td className="bg-amber-50 p-4 font-bold text-center">お申込の流れ</td>
                <td className="p-4 text-sm leading-relaxed">
                  <p className="mb-3">「mail@dynavisioncs.co.jp」からのメール受信許可設定をしてください。</p>
                  <p className="mb-2">
                    <strong>1. 注文確認メールが届きます。</strong><br />
                    お申込み後、注文確認の自動返信メールが届きます。万が一、時間が経ってもメールが届かない場合には、迷惑メールボックスに振り分けられていないかご確認の上、以下のページもご参照ください。<br />
                    <a 
                      href="https://www.dynavision.co.jp/MAIL.html" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-cyan-600 hover:underline"
                    >
                      https://www.dynavision.co.jp/MAIL.html
                    </a>
                  </p>
                  <p className="mb-2">
                    <strong>2. 銀行振込を選択された場合には、入金の確認が取れた時点で確認のメールが届きます。</strong>
                  </p>
                  <p className="mb-3">
                    <strong>3. 前日までに事前案内をお送りいたします。</strong><br />
                    (開催当日にお申し込みの方は開催時間までにご案内をお送りいたします。)
                  </p>
                  <p className="font-bold mb-2">■迷惑メールフォルダをご確認ください</p>
                  <p>迷惑メールフィルターを利用されている場合、弊社からのメールマガジンが[迷惑メール]フォルダーに振り分けられることがあります。弊社からのメールを受信できるよう、フィルター設定をしてください。メールマガジンなどが自動的に[迷惑メール]フォルダーに振り分けられてしまう場合、フィルターを設定すると、次回からは[受信箱]フォルダーなど指定したフォルダーにメールが届きます。</p>
                </td>
              </tr>
              <tr>
                <td className="bg-amber-50 p-4 font-bold text-center">お問い合わせ</td>
                <td className="p-4 text-sm">
                  <p className="mb-2">その他、ご質問がございましたら、お気軽にお電話かメールでダイナビジョンまでご連絡ください。</p>
                  <p>●問い合わせ先メールアドレス<br />メール:mail@dynavisioncs.co.jp<br />件名:『レインボードラゴン・マスター』</p>
                </td>
              </tr>
              <tr>
                <td className="bg-amber-50 p-4 font-bold text-center">【重要】<br />キャンセルについて</td>
                <td className="p-4">
                  オンラインコンテンツという特性上、受講料金をお支払い後、いかなる理由におきましても100%のキャンセル料金が発生いたします。
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* 申し込みボタン3 */}
        <div className="text-center mb-12">
          <div className="text-sm mb-4">
            <a 
              href="https://dynavision.co.jp/mensekijikou.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              免責事項
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_02.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              キャンセル規定
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_03.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              プライバシーポリシー
            </a>
          </div>
          <a 
            href="https://rainbowshop.lolipop.jp/rainbowangel/landing/LuckyBag2026/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block"
          >
            <img 
              alt="規約に同意して申し込む" 
              className="w-full max-w-2xl h-auto hover:opacity-90 transition-opacity cursor-pointer" 
              src="https://keikoanaguchi.com/RD24/moushi.png"
            />
          </a>
        </div>

        {/* 遠隔ヒーラー養成コース説明 */}
        <div className="mb-12 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-8">
          <div className="text-center mb-6">
            <img 
              alt="遠隔ヒーラー養成コース" 
              className="w-full max-w-2xl h-auto mx-auto" 
              src="https://keikoanaguchi.com/Abundance2020/src_files/Enkaku_title2.png"
            />
          </div>
          <div className="text-base leading-relaxed text-gray-700 space-y-4">
            <p>
              「遠隔ヒーラー養成コース」というのは、穴口が行う「遠隔」の手法を学んでいただき、ただ単にあなたが穴口から「遠隔」を受け取るだけではなく、
              <strong>「遠隔ヒーラー養成コース」を受講された方がご自身でも「遠隔ヒーリング&アクティベーション」を行う事ができるようになっていただくためのものです。</strong>
            </p>
            <p>
              「遠隔」は受け取るのみ、<strong>「遠隔ヒーラー養成コース」は自分でも「遠隔ヒーリング&アクティベーション」ができるようになるためのもの</strong>と考えていただくとわかりやすいかと思います。
            </p>
            <p>
              「遠隔ヒーリング&アクティベーション」はもちろん、<strong>クライアントさんやご家族、ご友人といった他者に行っていただいても良いですが、受け取った遠隔のエネルギーとくり返し繋がり、ご自身に対してエネルギーを送り続けるためにもおすすめです。</strong>
            </p>
            <p>なお、「遠隔ヒーラー養成コース」でお伝えするのは「遠隔ヒーリング&アクティベーション」の手法となります。</p>
          </div>
        </div>

        {/* よくある質問 */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <img 
              alt="よくある質問" 
              className="w-full max-w-2xl h-auto mx-auto" 
              src="https://keikoanaguchi.com/Abundance2020/src_files/Enkaku_titleQA.png"
            />
          </div>

          <div className="space-y-4">
            <details className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <summary className="p-4 font-bold cursor-pointer hover:bg-gray-50 flex items-start gap-3">
                <span className="text-orange-600 flex-shrink-0">Q.</span>
                <span>レインボードラゴンのエネルギーを伝授とレインボードラゴン・マスターの違いを教えてください。</span>
              </summary>
              <div className="p-4 pt-0 pl-10 text-gray-700 text-sm leading-relaxed">
                <p>穴口恵子からレインボードラゴンのエネルギーを伝授された人は遠隔ヒーリング&アクティベーションのエネルギーを受け取るのみです。一方で、穴口恵子のレインボードラゴン・マスターはエネルギーを受け取るだけでなく、他者へも遠隔ヒーリング&アクティベーションを行うことができるようになります。</p>
              </div>
            </details>

            <details className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <summary className="p-4 font-bold cursor-pointer hover:bg-gray-50 flex items-start gap-3">
                <span className="text-orange-600 flex-shrink-0">Q.</span>
                <span>遠隔は本当に効果があるのでしょうか?</span>
              </summary>
              <div className="p-4 pt-0 pl-10 text-gray-700 text-sm leading-relaxed">
                <p>効果があるので、実際に多くの人は受けています。そして、その人の人生がどんどん変化して、霊的、感情的…何らかの方向性で進化しています。</p>
                <p>経済的に豊かになっていく人、創造性が発揮され、才能が開花して、さらに活躍していく人など、人によってさまざまです。その人の本来の魂の計画に沿って生きられるようになっていきます。</p>
              </div>
            </details>

            <details className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <summary className="p-4 font-bold cursor-pointer hover:bg-gray-50 flex items-start gap-3">
                <span className="text-orange-600 flex-shrink-0">Q.</span>
                <span>遠隔はどんな風に感じますか?どんな変化がありますか?</span>
              </summary>
              <div className="p-4 pt-0 pl-10 text-gray-700 text-sm leading-relaxed">
                <p>人によって、受け取り方や感じ方が異なりますが、実際にお受けくださったお客様からのご感想として、「体がポカポカしてきた、ピリピリした」「涙が出てきた」「光の玉のようなものが見えた」「不思議な夢をみた」「ビジョンが見えた」などの感覚的なものから、「滞ってた問題が一気に解決した」「臨時収入が入ってきた」「恋愛が進展した」などの具体的なものまで、様々なご感想が届いています。</p>
              </div>
            </details>

            <details className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <summary className="p-4 font-bold cursor-pointer hover:bg-gray-50 flex items-start gap-3">
                <span className="text-orange-600 flex-shrink-0">Q.</span>
                <span>直接会ってのヒーリングと遠隔とで、効果の差はありますか?</span>
              </summary>
              <div className="p-4 pt-0 pl-10 text-gray-700 text-sm leading-relaxed">
                <p>遠隔でも直接お会いしても効果は同じです。ときには遠隔の方がよく効いていると感じる方がいるのは、ディバインセルフ(※)を通して受け取ることで、より受け取りやすい方がいるためです。あなたのディバインセルフにお任せしていただくのが遠隔の醍醐味です。</p>
                <p>あなたがまだ会社にお勤めであったり、小さなお子さんがいたり、ご家族の介護などの理由で外出する事が難しくても大丈夫です。この遠隔ヒーリングを取り入れる事で、場所に関わらずヒーラーとしてのキャリアをスタートさせる事が可能ですので安心してください。</p>
              </div>
            </details>

            <details className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <summary className="p-4 font-bold cursor-pointer hover:bg-gray-50 flex items-start gap-3">
                <span className="text-orange-600 flex-shrink-0">Q.</span>
                <span>何も感じない時には、受け取れていないのでしょうか?</span>
              </summary>
              <div className="p-4 pt-0 pl-10 text-gray-700 text-sm leading-relaxed">
                <p>もし特に強い感覚がなかったとしても、エネルギーは確実に届いていますので、ご安心ください。</p>
                <p>遠隔当日にリアルタイムで感じる方もいらっしゃいますし、数日のタイムラグがあって変化などを感じられる方もいらっしゃいます。何事も疑いが入ると、受け取りにくい状態になってしまいますので、リラックスして、信頼することが大切です。</p>
              </div>
            </details>
          </div>
        </div>

        {/* 最後に */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">最後に</h2>

          <div className="text-base leading-relaxed text-gray-700 space-y-4">
            <p>ここまで読んでいただきありがとうございます。</p>
            <p>最後に、どうしてもあなたにお伝えしたいことがあります。</p>
            <p className="font-semibold">地球の大変革期に突入している今、"恐れ"や"不安"に飲み込まれず、宇宙の無限の豊かさのボルテックスの中で生きるのを選択すること。</p>
            <p className="font-semibold">レインボードラゴンのエネルギーと繋がり、大切な人や自分を癒すことができる遠隔ヒーリングのスキルを身につけること。</p>
            <p className="mt-6">頭のいいあなたは、もう気づいているでしょう。</p>
            <p>
              なかなか思うように行かない人生、周りに流される人生、言われるがままの人生…こんな<strong>不安や恐怖の架空の人生</strong>を抜け出し、自由で豊かな、愛と光にあふれる世界で本当のあなたの存在価値を発揮すること。そしてともに幸せになること。
              <strong>遠隔ヒーリングは、今もこれからも、更に求められる重要なスキルです。</strong>
            </p>
            <p className="font-semibold">あなたは、もっともっと活躍できることがあるはずです。</p>
            <p className="font-semibold">あなたが、もっと自分の存在意義や存在価値を見出し、それを世の中に届けることで、多くの人の役に立ち、尊敬され、感謝されるあなたになれるはずです。</p>

            <p className="font-bold mt-6">特に今、</p>

            <div className="space-y-2 my-6">
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">龍やドラゴンが好き。彼らとご縁を結んだり、深めたい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">レインボードラゴンが授けてくれる叡智や豊かさを、自由に受け取りたい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">レインボードラゴンとともに新しい世界を創造したい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">自分を癒し、そして他の方を癒せる遠隔ヒーラーになりたい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">周りの人や地球の最高・最善のために貢献したい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">この非常事態の中でも、どんな状況にも左右されず、自分や周りを癒す力を発揮したい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">「私の人生これでいいの?」と漠然とした不安がある</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">「スピリチュアルを仕事にしたい」「好きなことを仕事にしたい」と考えている</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">自己ケアや誰かのためにヒーリングを身に着けたい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">既にヒーラーで、新しいスキルを身につけて新しいクライアントと出会いたい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">自己愛、自己信頼を高めたい</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="far fa-check-square text-teal-600 mt-1"></i>
                <span className="font-semibold">自信がないけど遠隔ヒーラーに興味がある</span>
              </p>
            </div>

            <p>このように考えている方には、<strong>募集が終了してしまう前に</strong>、ぜひこのスキルを受け取っていただきたいと思います。</p>
            <p className="text-right mt-8 font-semibold">穴口恵子</p>
          </div>
        </div>

        {/* 申し込みボタン4 */}
        <div className="text-center mb-12">
          <div className="text-sm mb-4">
            <a 
              href="https://dynavision.co.jp/mensekijikou.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              免責事項
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_02.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              キャンセル規定
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_03.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              プライバシーポリシー
            </a>
          </div>
          <a 
            href="https://rainbowshop.lolipop.jp/rainbowangel/landing/LuckyBag2026/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block"
          >
            <img 
              alt="規約に同意して申し込む" 
              className="w-full max-w-2xl h-auto hover:opacity-90 transition-opacity cursor-pointer" 
              src="https://keikoanaguchi.com/RD24/moushi.png"
            />
          </a>
        </div>

        {/* プロフィール */}
        <div className="mb-12 bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-8">
          <div className="mb-6">
            <img 
              alt="プロフィール" 
              className="w-full h-auto rounded-lg shadow-md mb-6" 
              src="http://keikoanaguchi.com/Egypt2019EK/img/profile.png"
            />
          </div>

          <div className="mb-6">
            <img 
              alt="穴口恵子" 
              className="w-full h-auto rounded-lg shadow-md" 
              src="https://keikoanaguchi.com/Abundance2020/img0003.jpg"
            />
          </div>

          <div className="text-center mb-6">
            <p className="font-bold text-lg">
              スピリアル®ライフ 提唱者<br />(株)ダイナビジョン 創始者
            </p>
          </div>

          <div className="text-sm leading-relaxed text-gray-700 space-y-3">
            <p>日々の生活のなかで実践するスピリアルライフを通し、誰もが無限の可能性を開き、人生のバランスをとりながら幸せで豊かに生きることを提唱する。</p>
            <p>これまでに、人材育成コンサルタントとしてソニー、シティバンク、本田技研、BMWをはじめとする数々のグローバルな上場企業等のコンサルティング、研修を行なう一方で、世界中に最高のメンターを探し求め、日本でそのプロデュースを行なうなど、世界最高レベルのものを人々に提供してきた。</p>
            <p>現在、日本でスピリチュアルスクールやショップの運営、セミナー事業等を行なうかたわら、聖地として名高いアメリカのシャスタ山でもショップを運営。世界各国からも招かれ、セミナーや個人セッションを行なっている。これまで25,000人以上に個人セッションを提供。</p>
            <p>また、数々の世界初のパワースポット遠隔伝授を開発し、延べ150,000人を超える参加者が受講している。</p>
            <p>スピリアルライフをサポートするセラピストの育成に特に注力しており、オリジナルのヒーリングやチャネリングメソッドの認定コースを全国で開催中。これまでに3,300人以上のセラピストを輩出している。</p>
            <p>2020年12月21日冬至、風の時代に突入して、大激動の新世界だからこそ、このスピリチュアル・スキルをぜひ受け取ってください。</p>
            <p>20年間で参加者15万人以上!数々のヒーリングコースを提供してきた穴口恵子からたっぷりとエッセンスを受け取ってください!</p>
          </div>
        </div>

        {/* 最終申し込みボタン */}
        <div className="text-center mb-12">
          <div className="text-sm mb-4">
            <a 
              href="https://dynavision.co.jp/mensekijikou.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              免責事項
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_02.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              キャンセル規定
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://dynavision.co.jp/sub04_03.html" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-600 hover:text-orange-600 mx-2"
            >
              プライバシーポリシー
            </a>
          </div>
          <a 
            href="https://rainbowshop.lolipop.jp/rainbowangel/landing/LuckyBag2026/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block"
          >
            <img 
              alt="規約に同意して申し込む" 
              className="w-full max-w-2xl h-auto hover:opacity-90 transition-opacity cursor-pointer" 
              src="https://keikoanaguchi.com/RD24/moushi.png"
            />
          </a>
        </div>
      </div>

      {/* フッター */}
      <footer className="bg-gradient-to-r from-amber-100 to-orange-100 py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm text-gray-700">
            株式会社ダイナビジョン ダイナビジョン<br />
            Copyright (C) Dynavision.,ltd All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
